// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"c8e26dd5","642":"94a7ad86"}[chunkId] || chunkId) + "." + {"538":"0344c5c833115cc5","642":"551f8f378a09e03e","680":"85605e5a475b16a8"}[chunkId] + ".js";
};